// extracted by mini-css-extract-plugin
export default {"icon":"StatusIcon_icon__W5Bf0","success":"StatusIcon_success__vGu3w","saving":"StatusIcon_saving__E5Ayu","error":"StatusIcon_error__cBMWh"};